import { PureComponent } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';

import { MOBILE } from '../../../data/screenSizes';

import { getBrowserScrollTop } from '../../../helpers/commonHelpers';
import withComponentName from '../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

export class ArticlesTitles extends PureComponent {
  constructor(props) {
    super(props);
    autoBind(this);
    this.onScrollEventAdded = false;
    const { articles } = props;
    this.ARTICLES_LIST = Object.entries(articles);
    this.state = {
      styles: {
        maxHeight: 'calc(100vh - 50px)',
        top: '50px',
      },
      mobileMenuOpened: false,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  componentDidUpdate(prevProps) {
    const {
      wrapperHeight: prevWrapperHeight, mode: prevMode, promobarHeight: prevPromobarHeight,
    } = prevProps;
    const { wrapperHeight, mode, promobarHeight } = this.props;
    if (mode !== prevMode) {
      this.setState(({ mobileMenuOpened }) => ({
        mobileMenuOpened: mode === MOBILE ? mobileMenuOpened : false,
      }));
      this.onScroll();
    } else if (prevWrapperHeight !== wrapperHeight || prevPromobarHeight !== promobarHeight) {
      this.onScroll();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    const { promobarHeight = 0, footerHeight, mode } = this.props;

    const scrollTop = getBrowserScrollTop();
    const topMargin = 50 - (scrollTop <= 50 ? scrollTop : 50);

    const height = topMargin + promobarHeight;
    let top = height;
    const distanceUntilBottom = (
      document.documentElement.scrollHeight - scrollTop - window.innerHeight
    );

    // for make menu bar stick if footer starts
    if (mode !== MOBILE && distanceUntilBottom <= footerHeight) {
      top -= footerHeight - distanceUntilBottom;
    }

    this.setState({
      styles: {
        maxHeight: `${window.innerHeight - height}px`,
        top: (mode === MOBILE ? ((promobarHeight === 72) ? `${promobarHeight}px` : '0px') : (`${top}px`)),
        position: mode === MOBILE ? 'sticky' : 'fixed',
      },
    });
  }

  toggleMobileMenu() {
    const { mode } = this.props;

    if (mode !== MOBILE) return;

    this.setState(({ mobileMenuOpened }) => ({
      mobileMenuOpened: !mobileMenuOpened,
    }));
  }

  render() {
    const { activeArticle, mode } = this.props;
    const { styles, mobileMenuOpened } = this.state;
    let { title } = this.ARTICLES_LIST[0][1];
    const showArticles = mode !== MOBILE || mobileMenuOpened;
    const selectedArticle = this.ARTICLES_LIST.find(([id]) => id === activeArticle);

    if (selectedArticle) title = selectedArticle[1].title;

    return (
      <aside style={styles} className={cx('articles-titles')}>
        <div className={cx('title', 'active', 'active-article')} onClick={this.toggleMobileMenu}>
          {title}
          <FontAwesomeIcon icon={mobileMenuOpened ? faChevronUp : faChevronDown} />
        </div>
        <div className={cx('titles-wrapper', { active: showArticles })}>
          {this.ARTICLES_LIST.map(([id, { title }]) => (
            <a
              key={id}
              className={cx('title', { active: id === activeArticle })}
              href={`#${id}`}
              onClick={this.toggleMobileMenu}
            >
              {title}
            </a>
          ))}
        </div>
      </aside>
    );
  }
}

function mapToStateProps({ promobar }) {
  return {
    promobarHeight: promobar.height,
  };
}

export default withComponentName(connect(mapToStateProps, null)(ArticlesTitles));
